import AddBlock from '@clearkit/icons/glyphs/AddBlock';
import AddHollow from '@clearkit/icons/glyphs/AddHollow';
import { CKButton, CKTooltip } from 'clearkit';
import isEqual from 'lodash/isEqual';
import { useMemo } from 'react';
import { v4 as uuidv4 } from 'uuid';

const FieldMappingFooter = ({
  addMapping,
  areFieldMappingsInvalid,
  className,
  isUpdating,
  setConfirmSaveDialogOpen,
  setShowInvalidFields,
  hasEnrichmentBetaUIFlag,
  fieldMappings,
  setFieldMappings,
  savedFieldMappings,
}) => {
  const areButtonsDisabled = useMemo(() => {
    if (!hasEnrichmentBetaUIFlag) {
      return areFieldMappingsInvalid;
    } else if (!fieldMappings?.length > 0) {
      return true;
    } else if (savedFieldMappings?.length > 0) {
      return isEqual(fieldMappings, savedFieldMappings);
    }

    return isEqual(fieldMappings, []);
  }, [fieldMappings, savedFieldMappings]);

  const SaveButton = () => {
    return (
      <CKButton
        isLoading={hasEnrichmentBetaUIFlag ? false : isUpdating}
        onClick={() => setConfirmSaveDialogOpen(true)}
        variant="bold"
        isDisabled={areButtonsDisabled || areFieldMappingsInvalid}
        dataTestId="FieldMappingFooter__submit"
        variantColor="green">
        {hasEnrichmentBetaUIFlag ? 'Save' : 'Save changes'}
      </CKButton>
    );
  };

  const AddButtons = () => {
    return (
      <div>
        {hasEnrichmentBetaUIFlag ? (
          <>
            <CKButton
              onClick={() => addMapping()}
              className="mr-4"
              variant="bold"
              variantColor="blue"
              leftIcon={<AddBlock />}>
              Add field mapping
            </CKButton>
            <CKButton
              onClick={() => addMapping({ groupId: uuidv4() })}
              variantColor="blue"
              leftIcon={<AddBlock />}>
              Add address group
            </CKButton>
          </>
        ) : (
          <>
            <CKButton
              onClick={() => addMapping()}
              className="mr-4"
              leftIcon={<AddHollow />}>
              Add mapping
            </CKButton>
            <CKButton
              onClick={() => addMapping({ groupId: uuidv4() })}
              leftIcon={<AddHollow />}>
              Add address group
            </CKButton>
          </>
        )}
      </div>
    );
  };

  return (
    <div className={classnames(className, 'grid grid-cols-2')}>
      <AddButtons />
      <div className="flex justify-end gap-3">
        {hasEnrichmentBetaUIFlag ? (
          <CKButton
            isDisabled={areButtonsDisabled}
            onClick={() => setFieldMappings(savedFieldMappings || [])}
            variant="simple"
            variantColor="default">
            Cancel
          </CKButton>
        ) : (
          <></>
        )}
        {areFieldMappingsInvalid ? (
          <CKTooltip
            tooltip="Some field mappings are invalid"
            placement="top-end">
            <div
              onMouseEnter={() => setShowInvalidFields(true)}
              onMouseLeave={() => setShowInvalidFields(false)}>
              <SaveButton />
            </div>
          </CKTooltip>
        ) : (
          <SaveButton />
        )}
      </div>
    </div>
  );
};

export default FieldMappingFooter;
